<cosmos-dynamic-form-v2 [form]="config.data.form" [model]="config.data.model || {}" [closeButton]="true" (formValue)="onFormSubmit($event)"></cosmos-dynamic-form-v2>
